import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/ingestion/testRestCall';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

// Test a REST connector through the ingestion proxy endpoint and return the
// sample response used for field mapping.
function* operation(action) {
  const { sourceId, endpoint, queryParams, method, requestBody } = action.payload;
  try {
    const params = new URLSearchParams();
    if (endpoint) {
      params.append('endpoint', endpoint);
    }
    if (queryParams) {
      try {
        const parsed = JSON.parse(queryParams);
        Object.entries(parsed).forEach(([key, value]) => {
          params.append(key, value);
        });
      } catch (e) {
        console.warn('Invalid query params JSON:', e);
      }
    }
    const finalUrl = `${config.API_URL}/ingestion/sources/${sourceId}/proxy?${params.toString()}`;
    const httpMethod = method || 'GET';
    const response = yield call(axios.request, {
      url: finalUrl,
      method: httpMethod,
      headers: { ...getLocalUser(), 'Content-Type': 'application/json' },
      data: ['POST', 'PUT', 'PATCH'].includes(httpMethod) && requestBody ? requestBody : undefined,
    });
    const result = response.data;

    // Handle nested data structure from proxy response
    if (result.data?.success && result.data?.data) {
      yield put(fetchSuccess({ data: result.data.data, metadata: result.data.metadata }));
    } else if (result.success && result.data) {
      // Handle direct success response
      yield put(fetchSuccess({ data: result.data }));
    } else {
      throw new Error(result.error || result.data?.error || 'Failed to fetch data from API');
    }
  } catch (error) {
    yield put(ErrorAction(error));
    const body = error.response?.data;
    const message = body
      ? (body.error || body.data?.error || 'Failed to fetch data from API')
      : (error.message || 'Failed to connect to API');
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
